import { render } from "./DiagnosisSchemaByPage.vue?vue&type=template&id=06e75662&scoped=true"
import script from "./DiagnosisSchemaByPage.vue?vue&type=script&lang=js"
export * from "./DiagnosisSchemaByPage.vue?vue&type=script&lang=js"

import "./DiagnosisSchemaByPage.vue?vue&type=style&index=0&id=06e75662&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e75662"]])

export default __exports__